export enum SalesforceSortOrder {
	Ascending = 0,
	Descending = 1,
}
